import React from 'react';
import PropTypes from 'prop-types';
import ErrorModal from 'components/ErrorModal';
import { DEFAULT_PROPERTY } from 'utils/constants';

const propTypes = {
  componentStack: PropTypes.string,
  error: PropTypes.instanceOf(Error)
};

function ErrorFallback({ componentStack, error }) {
  return (
    <ErrorModal
      property={DEFAULT_PROPERTY}
      isOpen={true}
      error={error}
      componentStack={componentStack}
    />
  );
}

ErrorFallback.propTypes = propTypes;

export default ErrorFallback;
